(() => {
  angular
    .module('gm.common.directives')
    .directive('gmCaptureMousewheel', gmCaptureMousewheelDirective);

  function preventBubble(event) {
    event.stopPropagation();
    event.preventDefault();
    event.returnValue = false;
    return false;
  }

  function gmCaptureMousewheelDirective() {
    'ngInject';

    return {
      restrict: 'A',
      link(scope, element) {
        let scrollPosition = 0;

        function bindMousewheel(event) {
          const scrollTop = element[0].scrollTop;
          const scrollHeight = element[0].scrollHeight;
          const height = element[0].clientHeight;
          const delta = ((event.type === 'DOMMouseScroll')
                ? event.originalEvent.detail * -40 : event.originalEvent.wheelDelta);
          const up = delta > 0;

          if (up && (delta > scrollTop)) {
            scrollPosition = 0;
          } else if (!up && (-delta > (scrollHeight - height - scrollTop))) {
            scrollPosition = scrollHeight;
          } else {
            scrollPosition += -delta;
          }
          element[0].scrollTop = scrollPosition;

          return preventBubble(event);
        }

        element.bind('DOMMouseScroll mousewheel', bindMousewheel);

        scope.$on('$destroy', () => {
          element.unbind('DOMMouseScroll mousewheel', bindMousewheel);
        });
      },
    };
  }
})();
